/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    projectStatus : null,
    notificationContent : null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.webDashboardAction.REQUEST_WEBDASHBOARD_DATA:
      return {
        ...state,
    };
    case actions.webDashboardAction.WEBDASHBOARD_DATA_RECEIVED:
          return{
      ...state,
      projectStatus : action?.data?.projectStatus,
      notificationContent : action?.data?.notificationContent,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
